{
  "name": "tdoe-frtn",
  "version": "0.0.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build-prod": "ng build --configuration=production --output-path=dist/prod",
    "build-uat": "ng build --configuration=uat --output-path=dist/uat",
    "build-dev": "ng build --configuration=development --output-path=dist/dev",
    "build-all": "concurrently \"npm run build-dev\" \"npm run build-uat\" \"npm run build-prod\"",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "prettier": {
    "printWidth": 100,
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "packageManager": "npm@11.6.0",
  "dependencies": {
    "@angular/animations": "^21.0.5",
    "@angular/cdk": "^21.0.3",
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/forms": "^21.0.0",
    "@angular/material": "^21.0.3",
    "@angular/platform-browser": "^21.0.0",
    "@angular/router": "^21.0.0",
    "@azure/msal-angular": "^4.0.23",
    "@azure/msal-browser": "^4.27.0",
    "@ngx-formly/core": "^7.0.1",
    "@ngx-formly/material": "^7.0.1",
    "@tdoe/design-system": "^20.3.0",
    "angular-svg-icon": "^19.1.1",
    "bootstrap": "^5.3.7",
    "countup.js": "^2.9.0",
    "ngx-countup": "^21.0.0",
    "ngx-skeleton-loader": "^11.3.0",
    "ngx-spinner": "^19.0.0",
    "ngx-timeago": "^4.0.0",
    "ngx-toastr": "^19.1.0",
    "route-parser": "^0.0.5",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.0.3",
    "@angular/cli": "^21.0.3",
    "@angular/compiler-cli": "^21.0.0",
    "@ngx-formly/schematics": "^7.0.1",
    "jsdom": "^27.1.0",
    "typescript": "~5.9.2",
    "vitest": "^4.0.8"
  }
}
